import { v4 as uuid } from 'uuid';
import { mergeMap, of } from "rxjs";
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as FlatActions from '@medsurf/flat-actions';
import * as FlatStates from '@medsurf/flat-states';
import * as FlatModels from "@medsurf/flat-models";

@Injectable()
export class AnnotationLabelEntityFacade {
  constructor(protected store: Store) {
  }

  //<editor-fold desc="Selectors">

  //</editor-fold>

  //<editor-fold desc="Requests">
  
  static getNewInstance(id: string,
                        annotation: FlatModels.AnnotationEntityModels.AnnotationEntityType,
                        text: string,
                        fontSize: number | null = null) {
    const annotationLabel: FlatModels.AnnotationLabelEntityModels.AnnotationLabel = {
      id,
      text,
      description: null,
      align: null,
      pivot: 'bottomCenter',
      color: null,
      border: false,
      hidden: false,
      borderColor: null,
      borderWidth: null,
      fontSize,
      background: {
        color: null,
        opacity: 0
      },
      annotation: annotation.id
    }
    return annotationLabel;
  }
  
  static addAnnotationLabel(store: Store,
                            id: string,
                            annotation: FlatModels.AnnotationEntityModels.AnnotationEntityType,
                            text: string,
                            fontSize: number | null = null) {
    // Get New Instance
    const annotationLabel = AnnotationLabelEntityFacade.getNewInstance(id, annotation, text, fontSize);
    
    // Add Annotation Label
    return store.dispatch(new FlatActions.AnnotationLabelEntityActions.AddEntity(annotationLabel)).pipe(
      mergeMap((data) => of({data, annotationLabel})),
    );
  }
  
  static getCopyInstance(store: Store,
                         id: string,
                         annotation: FlatModels.AnnotationEntityModels.AnnotationEntityType) {
    // Get Data
    const typedAnnotationLabels = store.selectSnapshot(FlatStates.AnnotationLabelEntityState.typedEntities$);
    
    // Get Annotation Label
    const annotationLabel = structuredClone(typedAnnotationLabels[id]);
    
    // Update Annotation Label
    annotationLabel.id = uuid();
    annotationLabel.annotation = annotation.id;
    
    return annotationLabel;
  }

  //</editor-fold>
}
